import { useEffect, useState } from "react";
import { Navigate, BrowserRouter, Routes, Route } from "react-router-dom";

import LandingPage from "./pages/LandingPage";
import { isMobileDevice } from "./utils/device";
import WebsiteGenerator from "./pages/GenerateWebsitePage";
import ProgramsManagerPage from "./pages/ProgramsManagerPage";
import DevPlaygroundPage from "./pages/DevPlaygroundPage";
import MobileLandingPage from "./pages/MobileLandingPage";
import MobileGeneratePage from "./pages/MobileGeneratePage";
import LegalPage from "./pages/LegalPage";
import HelpCenterPage from "./pages/HelpCenterPage";
import HelpArticlePage from "./pages/HelpArticlePage";
import GenerateWebsitePageRouter from "./pages/GenerateWebsitePageRouter";

function useIsMobileRoute() {
    const [isMobile, setIsMobile] = useState(() => isMobileDevice());

    useEffect(() => {
        const update = () => {
            setIsMobile(isMobileDevice());
        };

        update();

        window.addEventListener("resize", update);
        window.visualViewport?.addEventListener("resize", update);
        window.addEventListener("orientationchange", update);

        return () => {
            window.removeEventListener("resize", update);
            window.visualViewport?.removeEventListener("resize", update);
            window.removeEventListener("orientationchange", update);
        };
    }, []);

    return isMobile;
}

function AppRoutes() {
    const isMobile = useIsMobileRoute();

    return (
        <Routes>

            <Route path="/terms" element={<LegalPage />} />
            <Route path="/privacy" element={<LegalPage />} />
            <Route path="/refund-policy" element={<LegalPage />} />
            <Route path="/delivery-policy" element={<LegalPage />} />
            <Route path="/contact" element={<LegalPage />} />
            <Route path="/help" element={<HelpCenterPage />} />
            <Route path="/help/:slug" element={<HelpArticlePage />} />
            <Route
                path="/"
                element={isMobile ? <MobileLandingPage /> : <LandingPage />}
            />

            <Route
                path="/generate"
                element={
                    isMobile
                        ? <Navigate to={`/generate/mobile${window.location.search || ""}`} replace />
                        : <GenerateWebsitePageRouter />
                }
            />

            <Route
                path="/generate/mobile"
                element={
                    isMobile
                        ? <MobileGeneratePage />
                        : <Navigate to={`/generate${window.location.search || ""}`} replace />
                }
            />

            <Route path="/crm/programs" element={<ProgramsManagerPage />} />
            <Route path="/dev/playground" element={<DevPlaygroundPage />} />
        </Routes>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AppRoutes />
        </BrowserRouter>
    );
}

export default App;